export class Type2Model {
    public Id: number;
    public Name: string;
    public CreatedDate: Date;
    public LastUpdatedDate: Date;
    public AccountId: number;
    public SiteId: number;
}



// WEBPACK FOOTER //
// ./src/app/models/type2-model.ts